import { Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'store';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { openSnackbar } from 'store/slices/snackbar';
import { useIntl } from 'react-intl';

const DownloadUpdates = ({ dataToDownload }: any) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const { loading } = useSelector((state) => state.healthContent);

    const downloadReport = () => {
        const workbook = XLSX.utils.book_new();

        const data = XLSX.utils.json_to_sheet(dataToDownload || [{}]);
        XLSX.utils.book_append_sheet(workbook, data, 'Data');

        XLSX.writeFile(workbook, 'data.xlsx');

        dispatch(
            openSnackbar({
                message: `${intl.formatMessage({ id: 'download_successfully' })}`,
                variant: 'success'
            })
        );
    };

    return (
        <Button
            startIcon={<FileDownloadIcon />}
            onClick={downloadReport}
            color="primary"
            variant="outlined"
            component="label"
            size="large"
            sx={{ zIndex: 1000 }}
            disabled={loading}
        >
            <Typography>Download</Typography>
        </Button>
    );
};
export default DownloadUpdates;
